<!--
客户退货申请单 - 单对象 - 原单编号
-->
<template>
  <div class="OC_B_ORDER_ID">
    <!-- <label class="itemLabel"> 零售发货单单号: </label> -->
    <Input :disabled="disabled" :autocomplete="'new-password'" @on-click="iconclick" @on-keydown="inputenter" :icon="iosSearch" v-model="BILL_NO" :placeholder="''" @on-blur="inputblur" @on-change="inputChange" />
    <Icon v-if="!disabled" class="oriCodeclear" type="ios-close-circle" @click="clear" />
    <!-- 查询【客户订单】 -->
    <Modal v-model="orderModal" width="900" titleAlign="left" :closable="true" @on-visible-change="modalChange" :mask="true" class-name="ark-dialog" title="关联原单">
      <div class="cus-modal">
        <div class="obj-table">
          <OmsTable :jordan-table-config="table" @on-row-click="onRowClick" @on-row-dblclick="onRowDblclick" @on-page-change="pageChange" @on-page-size-change="pageSizeChange" />
        </div>
      </div>
      <div class="dialog-footer" slot="footer">
        <OmsButton :btn-config="btnConfigMo" />
      </div>
    </Modal>
  </div>
</template>

<script>
// 退换货单详情
// import buttonPermissionsMixin from '@/assets/js/mixins/buttonPermissions';
// import dataAccessMixin from '@/assets/js/mixins/dataAccess';

export default {
  name: 'sourceBillNo',
  components: {},
  // model: {
  //   prop: 'value',
  //   event: 'change'
  // },
  props: {
    options: {
      type: Object,  // 框架传过来的
    }
  },
  // mixins: [buttonPermissionsMixin, dataAccessMixin],
  data() {
    return {
      disabled: false,
      iosSearch: 'ios-search',
      BILL_NO: '',
      orderModal: false,
      oldVal: '',
      loading: false,
      ID: this.$route.params.customizedModuleId && (this.$route.params.customizedModuleId != 'NEW' || this.$route.params.customizedModuleId != 'New') ? this.$route.params.customizedModuleId : '-1',
      backable: false,
      modal: false,
      getCurrenData: {},
      btnConfigMo: {
        typeAll: 'default',
        btnsite: 'right',
        buttons: [
          {
            text: $it('com.cancel'), // 取消
            btnclick: () => {
              this.table.selectionArr = [];
              this.orderModal = false;
            },
          },
          {
            text: $it('com.determine'), // 确定
            type: 'primary',
            btnclick: () => {
              if (!this.table.selectionArr.length) {
                this.$Message.warning('请选中一条单据！');
                return false;
              }
              this.BILL_NO = this.table.selectionArr[0].BILL_NO;
              // this.table.selectionArr[0].ID = this.BILL_NO;
              this.$emit('change', this.BILL_NO, this);
              this.orderModal = false;
              this.table.selectionArr = [];
            },
          },
        ],
      },
      table: {
        columns: [
          {
            key: 'BILL_NO',
            title: '单据编号',
          },
          {
            key: 'SOURCE_CODE',
            title: '来源单号',
          },
          {
            key: 'EXPRESS_CODE',
            title: '物流单号',
          },
          {
            key: 'CP_C_LOGISTICS_ENAME',
            title: '物流公司',
          },
          {
            key: 'ALL_SKU',
            title: $it('fL.barCode'), // 条码
          },
          {
            key: 'BUYER_NICK',
            title: '买家昵称',
          },
          {
            key: 'RECEIVER_NAME',
            title: '收货人',
          },
          {
            key: 'RECEIVER_MOBILE',
            title: '收货人手机',
          },
          {
            key: 'CP_C_CAPITAL_ACCOUNT_NAME',
            title: '资金账户',
          },
        ], // 表头
        data: [], // 数据配置
        selectionArr: [],
        indexColumn: true, // 是否显示序号
        height: '300',
        loading: false,
        isShowSelection: true, // 是否显示checkedbox
        pageShow: true, // 控制分页是否显示
        btnsShow: true, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        total: 0, // 设置总条数
        pageSizeOpts: [10, 20, 30, 50, 100], // 每页条数切换的配置
        pageSize: 10, // 每页条数
        pageIndex: 1, // 页码
        isShowSelection: true, // 是否显示checkedbox
        highlightRow: true, // 高亮单选必须结合它
        multiple: false, //false 单选
        businessFormConfig: {
          formValue: {
            BILL_NO: '',
            DELIVER_STATUS: ['2','3'],
            SOURCE_CODE: '',
            EXPRESS_CODE: '',
            RECEIVER_NAME: '',
            BUYER_NICK: '',
            RECEIVER_MOBILE: '',
          },
          formData: [
            {
              style: 'input',
              label: '单据编号',
              colname: 'BILL_NO',
              width: '8',
              inputenter: () => this.queryEnter(1, this.table.pageSize),
            },
            {
              style: 'input',
              label: '来源单号',
              colname: 'SOURCE_CODE',
              width: '8',
              inputenter: () => this.queryEnter(1, this.table.pageSize),
            },
            {
              style: 'input',
              label: '物流单号', // 物流单号
              colname: 'EXPRESS_CODE',
              width: '8',
              inputenter: () => this.queryEnter(1, this.table.pageSize),
            },
            {
              style: 'select',
              multiple: true,
              label: '发货状态',
              colname: 'DELIVER_STATUS',
              width: '8',
              options: [
                /* {
                  label: '未发货',
                  value: '1',
                }, */
                {
                  label: '部分发货',
                  value: '2',
                },
                {
                  label: '全部发货',
                  value: '3',
                },
              ],
              inputenter: () => this.queryEnter(1, this.table.pageSize),
            },
            /* {
              style: 'input',
              label: $it('fL.consignee'), // 收货人
              colname: 'RECEIVER_NAME',
              width: '8',
              inputenter: () => this.queryEnter(1, this.table.pageSize),
            },
            {
              style: 'input',
              label: $it('tL.buyerNickname'), // 买家昵称
              colname: 'BUYER_NICK',
              width: '8',
              inputenter: () => this.queryEnter(1, this.table.pageSize),
            },
            {
              style: 'input',
              label: $it('fL.consignee_phone'), // 收货人手机
              colname: 'RECEIVER_MOBILE',
              width: '8',
              inputenter: () => this.queryEnter(1, this.table.pageSize),
            }, */
          ],
        },
        businessButtonConfig: {
          typeAll: 'default', // 按钮统一风格样式
          btnsite: 'right',
          buttons: [
            {
              text: $it('btn.reset'), //重置
              disabled: false, // 按钮禁用控制
              btnclick: () => {
                this.table.businessFormConfig.formValue.BILL_NO = '';
                this.table.businessFormConfig.formValue.SOURCE_CODE = '';
                this.table.businessFormConfig.formValue.DELIVER_STATUS = ['2','3'];
                this.table.businessFormConfig.formValue.EXPRESS_CODE = '';
                this.table.businessFormConfig.formValue.RECEIVER_NAME = '';
                this.table.businessFormConfig.formValue.BUYER_NICK = '';
                this.table.businessFormConfig.formValue.RECEIVER_MOBILE = '';
                console.log('this.table.businessFormConfig.formValue:', this.table.businessFormConfig.formValue);
                // this.formEmpty(this, 'formConfig', ['ORDER_DATE', 'PAY_TIME']);
                this.queryEnter(1, this.table.pageSize);
              }, // 按钮点击事件
            },
            {
              text: $it('btn.find'), // 查找 按钮文本
              disabled: false, // 按钮禁用控制
              type: 'primary',
              btnclick: () => {
                this.queryEnter(1, this.table.pageSize);
              }, // 按钮点击事件
            },
          ],
        },
      },
    };
  },
  watch: {
    BILL_NO(newVal) {
      if (!newVal) {
      }
    },
  },
  created() {
    console.log();
  },
  mounted() {
    if (!(this.$route.params.itemId == 'New')) {
      this.disabled = true;
      this.iosSearch = '';
      setTimeout(() => {
        this.BILL_NO = this.options.valuedata;
      }, 100);
    }
  },
  methods: {
    modalChange(e) {
      if (!e) {
        this.table.selectionArr = [];
      }
    },
    clear() {
      this.BILL_NO = '';
      this.$emit('change', '');
      // 设置清除
      R3.store.commit('customize/clear', true);
    },
    iconclick() {
      this.table.businessFormConfig.formValue.BILL_NO = '';
      this.table.businessFormConfig.formValue.SOURCE_CODE = '';
      this.table.businessFormConfig.formValue.EXPRESS_CODE = '';
      this.table.businessFormConfig.formValue.RECEIVER_NAME = '';
      this.table.businessFormConfig.formValue.BUYER_NICK = '';
      this.table.businessFormConfig.formValue.RECEIVER_MOBILE = '';
      // 获取
      this.queryEnter();
      this.orderModal = true;
    },
    inputenter(val) {
      if (val.keyCode == 13) {
        let str = val.target.value.replace(/\s+/g, '');
        console.log('inputenter::', str);
        if (str == this.oldVal) {
          // 值未变不会触发change调接口，特此处理
          this.$emit('change', '' + Date.now());
          setTimeout(() => {
            this.$emit('change', str);
          }, 1);
        } else {
          this.oldVal = str;
          this.$emit('change', str);
        }
      }
    },
    inputblur() {},
    inputChange(val) {},
    /* --------------------- 工具函数： --------------------- */
    keyDown() {},
    /* ------------------- 事件 part start ------------------- */
    async queryEnter(pageNum = 1, pageSize = 10, enter) {
      const self = this;
      this.table.loading = true;
      let formValue = this.table.businessFormConfig.formValue;
      let paramsNull = '';
      let params = {
        pageNum: pageNum,
        pageSize: pageSize,
        BILL_NO: formValue.BILL_NO || enter ? formValue.BILL_NO || enter : paramsNull,
        SOURCE_CODE: formValue.SOURCE_CODE ? formValue.SOURCE_CODE : paramsNull,
        EXPRESS_CODE: formValue.EXPRESS_CODE ? formValue.EXPRESS_CODE : paramsNull,
        RECEIVER_NAME: formValue.RECEIVER_NAME ? formValue.RECEIVER_NAME : paramsNull,
        BUYER_NICK: formValue.BUYER_NICK ? formValue.BUYER_NICK : paramsNull,
        RECEIVER_MOBILE: formValue.RECEIVER_MOBILE ? formValue.RECEIVER_MOBILE : paramsNull,
      };
      const highSearch = [
        { type: 'Input', queryName: 'BILL_NO', value: params.BILL_NO },
        { type: 'Input', queryName: 'SOURCE_CODE', value: params.SOURCE_CODE },
        { type: 'Input', queryName: 'EXPRESS_CODE', value: params.EXPRESS_CODE },
        { type: 'Select', queryName: 'DELIVER_STATUS', value: formValue.DELIVER_STATUS.join() },
      ];
      const _params = { page: { pageSize, pageNum }, label: [], queryInfo: [], status: { label: '全部', value: '0', isShow: true }, highSearch, sort: [] };
      const formdata = new FormData();
      formdata.append('param', JSON.stringify(_params));
      self.service.common
        .publicUrlParams('/api/cs/dc/v1/order/select', formdata)
        .then((res) => {
          const {
            data: { orderLists, totalSize },
            code,
          } = res.data;
          if (code === 0) {
            this.table.data = orderLists;
            this.table.total = totalSize;
            if (enter) {
              this.$emit('change', '143234');
            }
          }
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    onRowClick(row, index) {
      const self = this;
      self.table.selectionArr[0] = row;
    },
    onRowDblclick(row) {
      const self = this;
    },
    pageChange(page) {
      this.table.pageIndex = page;
      this.queryEnter(page, this.table.pageSize);
    },
    pageSizeChange(size) {
      this.table.pageSize = size;
      this.queryEnter(1, size);
    },
    /* ------------------- 子表事件 part end ------------------- */
  },
  destroyed() {
    this.table.selectionArr = [];
  },
};
</script>

<style lang="less" scoped>
.searchOOID {
  /deep/ .button-combina .button-content {
    justify-content: flex-end;
  }
}
.OC_B_ORDER_ID {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .itemLabel {
    flex: 0 0 120px;
  }
  /deep/.ark-input-icon {
    // top: 5px;
    // right: 2px;
    height: 32px;
    line-height: 32px;
  }
  .oriCodeclear {
    position: absolute;
    top: 3px;
    right: 25px;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    z-index: 9;
    opacity: 0.7;
  }
}
</style>
